import { useState, useEffect } from 'react';

import { cohortsApi } from '../api';
import { getGuideLanguage } from '../views/Cohorts/utils';

export interface UseFacilitatorGuideResult {
  pdfAvailable: boolean;
  pptxAvailable: boolean;
  loaded: boolean;
}

/**
 * Fetches facilitator guide availability for the active guide language once on
 * mount. `loaded` flips true on both success and error, so callers can
 * distinguish "still fetching" from "fetched but nothing available".
 */
export const useFacilitatorGuide = (): UseFacilitatorGuideResult => {
  const [pdfAvailable, setPdfAvailable] = useState<boolean>(false);
  const [pptxAvailable, setPptxAvailable] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    cohortsApi.getFacilitatorGuideAvailability(
      getGuideLanguage(),
      (data) => {
        setPdfAvailable(data.pdf);
        setPptxAvailable(data.pptx);
        setLoaded(true);
      },
      () => setLoaded(true),
    );
  }, []);

  return { pdfAvailable, pptxAvailable, loaded };
};
